package top.wcpe.allincore.ui.runtime.render.model

import kotlin.jvm.JvmName

/**
 * 渲染批次：一组共享相同分桶键（type + texture + clipId）的不可变命令列表。
 *
 * ADR-0072 决策 1 镜像：真源为 `platform-client-api` 的
 * `top.wcpe.allincore.platform.client.api.render.batch.RenderBatch`
 * （纯 Java 8 对外 API，按 ADR-0002 不得 KMP 化）。真源为 `@Getter` 值对象（无 equals），
 * 镜像同样不重写 equals；真源以 `Collections.unmodifiableList` 包装命令列表，
 * 镜像改为只读快照（语义更强的不可变，无调用方依赖别名可变性），
 * 一致性由 jvmTest 的 RenderModelConsistencyTest 逐字段 roundtrip 守护。
 */
class RenderBatch(
    @get:JvmName("type") val type: RenderCommandType,
    @get:JvmName("texture") val texture: String?,
    @get:JvmName("clipId") val clipId: Int,
    commands: List<RenderCommand>,
) {

    /** 批内命令的只读快照。 */
    @get:JvmName("commands")
    val commands: List<RenderCommand> = commands.toList()

    fun size(): Int = commands.size
}
